export const fetchFn = window.fetch;
